import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { Col, FormFeedback, Input, Label, Row } from 'reactstrap'
import { InputNumber, InputText } from '../../../components/inputs'
import Select from 'react-select'
import { enumTypesPersons as entities } from './options'
import Divider from '../../../components/divider'
import { useSelector } from 'react-redux'
import CurrencyInput from 'react-currency-input-field'

const FormBase = ({
  input = {},
  initialTypeEntity = { value: null, label: null },
}) => {
  const { LEGAL, NATURAL } = entities
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext()

  const [entitySelected, setEntity] = React.useState(
    initialTypeEntity?.value
  )
  const { data, modal } = useSelector(
    (state) => state.productServiceMaster
  )
  const userInfo = useSelector((state) => state.businessManager)
  const { measurementUnits, productTypes } = useSelector(
    (state) => state.invoiceIssuance
  )

  const filteredOptions = productTypes.filter((option) => {
    if (userInfo?.data?.typeOffer.value === '01' && !modal.edit.open) {
      setValue('prodType', { value: '01', label: 'Producto' })

      return option.value === '01'
    }
    if (userInfo?.data?.typeOffer.value === '02' && !modal.edit.open) {
      setValue('prodType', { value: '02', label: 'Servicio' })
      return option.value === '02'
    }
    return true
  })

  if (!modal.edit.open) {
    const codes = data.map((item) => Number(item.productCode ?? 0))
    const currentMaxCode = codes.length === 0 ? 0 : Math.max(...codes)
    setValue('productCode', `${currentMaxCode + 1}`.padStart(4, '0'))
  }
  const handleOnchangeSelectEntity = (e) => {
    setEntity(e.value)
    setValue('NIT', '')
    setValue('NRC', '')
    setValue('DUI', '')
  }

  const [servicesSelected, setServicesSelected] = React.useState({
    service_to_acquire_digital_signature: [],
    service_to_acquire_digital_invoice: [],
  })

  const handleOnchangeSignatureDigital = (e) => {
    setServicesSelected({
      ...servicesSelected,
      service_to_acquire_digital_signature: e,
    })
  }

  const handleOnchangeDigitalInvoice = (e) => {
    setServicesSelected({
      ...servicesSelected,
      service_to_acquire_digital_invoice: e,
    })
  }

  console.log('Errors', errors)

  return (
    <React.Fragment>
      {/* <Row className="mx-0" style={{ paddingTop: '2%', paddingLeft: '5%' }}> */}
      <Divider title="Información principal" />
      <Row className="mb-1">
        <Col
          md="6"
          sm="12"
        >
          <InputNumber
            label={'Código del producto/servicio'}
            errors={errors}
            control={control}
            disabled={/*modal.edit.open*/ true}
            options={{
              id: 'productCode',
              name: 'productCode',
              maxLength: 9,
              startWithCero: true,
            }}
          />
        </Col>
        <Col
          md="6"
          sm="12"
        >
          <InputText
            label={'Nombre de producto/servicio*'}
            errors={errors}
            options={{
              control,
              id: 'productName',
              name: 'productName',
              // disabled: true
            }}
          />
        </Col>
      </Row>
      <Row className="mb-1">
        <Col
          md="6"
          sm="6"
        >
          <Label>Tipo de producto*</Label>
          <Controller
            name="prodType"
            control={control}
            render={({ field }) => (
              <>
                <Select
                  {...field}
                  name="prodType"
                  id="prodType"
                  //value={typesPersons.find((item) => item.value === entitySelected) || null}
                  options={filteredOptions}
                />
                {errors.prodType && (
                  <FormFeedback className="d-block">
                    {errors.prodType.message}
                  </FormFeedback>
                )}
              </>
            )}
          />
        </Col>

        <Col
          md="6"
          sm="12"
        >
          {/* <InputCurrency
            label={"Precio unitario*"}
            errors={errors}
            control={control}
            options={{
              id: "price",
              name: "price"
            }}
          /> */}
          <Label className="me-1">Precio*</Label>
          <Controller
            name="price"
            control={control}
            render={({ field: { onChange, value, ref } }) => (
              <>
                <CurrencyInput
                  id="input-price"
                  name="price"
                  placeholder="Por favor ingrese un número"
                  value={value} // Valor actual del input
                  decimalsLimit={2}
                  groupSeparator=","
                  decimalSeparator="."
                  prefix="$"
                  className={`form-control ${
                    errors.price ? 'is-invalid' : ''
                  }`} // Aplica estilos de reactstrap
                  onValueChange={(value) => onChange(value)} // Actualiza el valor del formulario
                  inputRef={ref} // Referencia para react-hook-form
                />
                {errors.price && (
                  <FormFeedback className="d-block">
                    {errors.price.message}
                  </FormFeedback>
                )}
              </>
            )}
          />
        </Col>
      </Row>

      <Row className="mb-1">
        <Col
          md="6"
          sm="12"
        >
          <Label className="me-1">Unidad de medida*</Label>
          <Controller
            name="unitOfMeasure"
            control={control}
            render={({ field }) => (
              <>
                <Select
                  {...field}
                  options={measurementUnits}

                  //value={filterProps.codeType ? { value: filterProps.codeType, label: filterProps.codeType === 'dui' ? 'DUI' : 'NIT' } : null}
                  //onChange={(e) => {
                  //field.onChange(e.value)
                  //setFilterProps({ ...filterProps, codeType: e.value})
                  //setValue('clientCode', '')
                  //}}
                />
                {errors.unitOfMeasure && (
                  <FormFeedback className="d-block">
                    {errors.unitOfMeasure.message}
                  </FormFeedback>
                )}
              </>
            )}
          />
        </Col>
        <Col
          md="6"
          sm="12"
        >
          <Label className="me-1">Descripción*</Label>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <>
                <Input
                  {...field}
                  errors={errors}
                  options={{
                    control,
                    id: 'description',
                    name: 'description',
                    // disabled: true
                  }}
                />
                {errors.description && (
                  <FormFeedback className="d-block">
                    {errors.description.message}
                  </FormFeedback>
                )}
              </>
            )}
          />
        </Col>
        <Col
          md="6"
          sm="12"
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            marginTop: '8px',
          }}
        >
          <Label check>
            <Controller
              name="isActive"
              control={control}
              defaultValue={true}
              render={({ field }) => (
                <Input
                  {...field}
                  type="checkbox"
                  checked={field.value}
                  id="isActive"
                />
              )}
            />{' '}
            Activo
          </Label>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default FormBase
